import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

export function initializeSentry() {
  const domain = window.location.host;
  let env;
  if (domain.includes('urbanmetrix.com')) {
    env = domain.split('.')[0];
  } else if (domain.includes('localhost')) {
    env = 'local';
  } else {
    env = 'unknown';
  }

  Sentry.init({
    enabled: import.meta.env.VITE_SENTRY_ENABLED === '1',
    environment: env,
    dsn: import.meta.env.VITE_SENTRY_DNS,
    ignoreErrors: [/Object Not Found Matching Id:\d+,\s*MethodName:update,\s*ParamCount:\d+/],
    // Adds request headers and IP for users, for more info visit:
    sendDefaultPii: true,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
      Sentry.replayIntegration({
        stickySession: false,
        networkDetailAllowUrls: [`${window.location.origin}/api`, `${import.meta.env.VITE_SERVER_URL}/api`],
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false,
      }),
    ],
    enableLogs: true,
    tracesSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  });

  Sentry.setTag('version', import.meta.env.VITE_VERSION);
}
